import commonUtils from "@/utils/common.utils";
import store from "../store/store";
import auth from "@/utils/auth.utils";
import Swal from "sweetalert2";

const memberPageGuard = async (to, from, next) => {
  // 沒有 token 保持未登錄狀態停留在 member page
  if (!store.getters['userData/accessToken']) {
    next()
    return
  }
  // 如果token 過期則顯示錯誤訊息並登出 停留在 member page
  if (!store.getters['userData/isLogin']) {
    if (!Swal.isVisible()) commonUtils.createToast("error", "登入狀態已經過期,請重新登入");
    auth.logout();
    next()
    return
  }
  // 如果有 token 先進行判斷 from.params.store 和 to.params.store 是否相同
  // 不同的話使用 切換商店 api
  // 切換成功後儲存 token
  const currentStore = store.getters["userData/storeCode"];
  if (to.params.store !== currentStore) {
    try {
      const sendData = {
        store_code: to.params.store
      }
      await store.dispatch('userData/changeStore', sendData)
      await store.dispatch('basic/fetchStoreInfo')
      // 切換店家時清空購物車
      store.commit('cart/setCart', [])
    } catch (e) {
      let errorMessage = e
      if (errorMessage == 'No Such Store') errorMessage = '查無此店家'
      commonUtils.createToast("error", errorMessage);
      next({ path: `/${currentStore}` });
      return
    }
  }
  next()
};

export default memberPageGuard;
